export const systemSection = '/system';

export const systemPath = systemSection;
export const usersPath = systemSection + '/users';
export const rolesPath = systemSection + '/roles';
export const merchantsPath = systemSection + '/merchants';
export const banksPath = systemSection + '/banks';
export const developersPath = systemSection + '/developers';
export const businessProfileRoute = systemSection + '/business-profile';
export const webhooksPath = systemSection + '/webhooks';

export const userInvitePath = usersPath + '/invite-user';
export const userDetailPath = (id: string) => `${usersPath}/${id}`;
export const userDetailRoute = usersPath + '/:id';

export const rolesListPath = rolesPath;
export const roleCreatePath = `${rolesPath}/create`;
export const roleCreateRoute = `${rolesPath}/create`;
export const roleDetailPath = (id: string) => `${rolesPath}/${id}`;
export const roleDetailRoute = `${rolesPath}/:id`;
export const roleEditPath = (id: string) => `${rolesPath}/${id}/edit`;
export const roleEditRoute = `${rolesPath}/:id/edit`;

export const merchantsDetailPath = (id: string) => `${merchantsPath}/${id}`;
export const merchantsDetailRoute = merchantsPath + '/:id';
export const merchantBankAccountApprovalPath = (merchantId: string, bankAccountId: string) =>
  `${merchantsPath}/${merchantId}?approveBankAccount=${bankAccountId}`;

export const banksDetailPath = (id: string) => `${banksPath}/${id}`;
export const banksDetailRoute = banksPath + '/:id';
export const bankOnboardPath = `${banksPath}/onboard`;
export const bankOnboardRoute = `${banksPath}/onboard`;
export const bankUserInvitePath = (bankId: string) => `${banksPath}/${bankId}/invite-user`;
export const bankUserInviteRoute = `${banksPath}/:id/invite-user`;

export const gatewaysPath = systemSection + '/gateways';
export const gatewayDetailPath = (id: string) => `${gatewaysPath}/${id}`;
export const gatewaysDetailRoute = gatewaysPath + '/:id';

export const apiKeysPath = developersPath;
export const apiLogDetailPath = (logId: string): string => `${developersPath}/api-log/${logId}`;
export const apiLogDetailRoute = `${developersPath}/api-log/:logId`;
export const apiLogsListPath = (): string => `${developersPath}/api-logs`;

export const webhooksListPath = webhooksPath;
export const webhookDetailPath = (id: string) => `${webhooksPath}/${id}`;
export const webhookDetailRoute = `${webhooksPath}/:id`;
export const webhookCreatePath = `${webhooksPath}/create`;
export const webhookCreateRoute = `${webhooksPath}/create`;
export const webhookEditPath = (id: string) => `${webhooksPath}/${id}/edit`;
export const webhookEditRoute = `${webhooksPath}/:id/edit`;
